import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import { dateClassRule, dateComparator, dateFilterParams, dateFormatter, dateValueGetter } from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";

export default () => [
    {
        pages: [paths.training],
        config: {
            headerName: getLocalizedString("ID"),
            field: "id",
            filter: "agSetColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
        }
    },
    {
        pages: [paths.training],
        config: {
            headerName: getLocalizedString("name"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.training],
        config: {
            headerName: getLocalizedString("description"),
            field: "description",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.training],
        config: {
            headerName: getLocalizedString("courseName"),
            field: "originalCourseName",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.training],
        config: {
            headerName: getLocalizedString("themeArea"),
            field: "area",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.training],
        config: {
            headerName: getLocalizedString("published"),
            field: "publishedString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.training],
        config: {
            headerName: getLocalizedString("recognitionPoints"),
            field: "points",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.training],
        config: {
            headerName: getLocalizedString("dateFrom"),
            field: "dateFrom",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.training],
        config: {
            headerName: getLocalizedString("dateTo"),
            field: "dateTo",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.training],
        config: {
            headerName: getLocalizedString("state"),
            field: "status",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.training],
        config: {
            headerName: getLocalizedString("instructor"),
            field: "instructorString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.training],
        config: {
            headerName: getLocalizedString("themes"),
            field: "themes",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.training],
        config: {
            headerName: getLocalizedString("length"),
            field: "length",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.training],
        config: {
            headerName: getLocalizedString("certification"),
            field: "certification",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.training],
        config: {
            headerName: getLocalizedString("usedSpaceMB"),
            field: "usedSpaceMB",
            filter: "agTextColumnFilter",
        }
    },

    {
        pages: ["/training/assignment"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "CODIGO DE EMPLEADO",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["/training/assignment"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "APELLIDO Y NOMBRE",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["/training/assignment"],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: "FECHA DE INGRESO",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ["/training/assignment"],
        config: {
            headerName: getLocalizedString("position"),
            field: "CARGO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment"],
        config: {
            headerName: getLocalizedString("function"),
            field: "FUNCIÓN",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment"],
        config: {
            headerName: getLocalizedString("management"),
            field: "GERENCIA",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment"],
        config: {
            headerName: getLocalizedString("department"),
            field: "DEPARTAMENTO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment"],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: "CENTRO DE COSTO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment"],
        config: {
            headerName: getLocalizedString("SHOW_DIVISION"),
            field: "UNIDAD DE NEGOCIO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment"],
        config: {
            headerName: getLocalizedString("email"),
            field: "EMAIL",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["/training/assignment"],
        config: {
            headerName: getLocalizedString("personalEmail"),
            field: "EMAIL PERSONAL",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["/training/assignment"],
        config: {
            headerName: getLocalizedString("workMode"),
            field: "MODALIDAD DE TRABAJO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment"],
        config: {
            headerName: getLocalizedString("manager"),
            field: "MANAGER",
            filter: "agTextColumnFilter",
        }
    },

    {
        pages: ["/training/assignment/userSelection"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "CODIGO DE EMPLEADO",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "APELLIDO Y NOMBRE",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "ESTADO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config:
        {
            headerName: getLocalizedString("icariusAccess"),
            field: "HABILITAR EL ACCESO A ICARIUS",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: "FECHA DE INGRESO",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config: {
            headerName: getLocalizedString("position"),
            field: "CARGO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config: {
            headerName: getLocalizedString("function"),
            field: "FUNCIÓN",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config: {
            headerName: getLocalizedString("fType"),
            field: "TIPO DE FUNCIONARIO",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "LUGAR DE TRABAJO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: "OBRA O FAENA",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: "CENTRO DE COSTO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config: {
            headerName: getLocalizedString("plantPersonnel"),
            field: "PERSONAL DE PLANTA",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config: {
            headerName: getLocalizedString("management"),
            field: "GERENCIA",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config: {
            headerName: getLocalizedString("department"),
            field: "DEPARTAMENTO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config: {
            headerName: getLocalizedString("jornadaType"),
            field: "TIPO DE JORNADA",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config: {
            headerName: getLocalizedString("SHOW_DIVISION"),
            field: "UNIDAD DE NEGOCIO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config: {
            headerName: getLocalizedString("email"),
            field: "EMAIL",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config: {
            headerName: getLocalizedString("personalEmail"),
            field: "EMAIL PERSONAL",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["/training/assignment/userSelection"],
        config: {
            headerName: getLocalizedString("workMode"),
            field: "MODALIDAD DE TRABAJO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["skillBasedTraining"],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "CODIGO DE EMPLEADO",
            filter: "agTextColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
        }
    },
    {
        pages: ["skillBasedTraining"],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: "APELLIDO Y NOMBRE",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ["skillBasedTraining"],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: "FECHA DE INGRESO",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ["skillBasedTraining"],
        config: {
            headerName: getLocalizedString("position"),
            field: "CARGO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ["skillBasedTraining"],
        config: {
            headerName: getLocalizedString("gap"),
            field: "BRECHA",
            filter: "agSetColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            cellRenderer: "GapRenderer",
        }
    },
    {
        pages: ["skillBasedTraining"],
        config: {
            headerName: getLocalizedString("result"),
            field: "RESULTADO",
            filter: "agSetColumnFilter",
            cellRenderer: "ResultRenderer",
        }
    },
]